import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import "react-datepicker/dist/react-datepicker.css";
import MUIDataTable from "mui-datatables";
import { Table } from 'reactstrap';
import { Button } from 'reactstrap';
import IconButton from '@mui/material/IconButton';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";

 // app config
 import AppConfig from 'Constants/AppConfig';
// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext, Dot } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';

import { 
    fetchCaptoReport,
    fetchPlayerCaptoLab,
    deleteCaptoReport,
 } from 'Actions';

 import AddItem from '../../../technologyreport/captoputtingreport/component/addform';
 import EditForm from '../../../technologyreport/captoputtingreport/component/editform';

 import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
 import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
 import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';

class CaptoItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,

    };

    UNSAFE_componentWillMount() {
	}
    constructor(props) {
      
        super(props);
        this.nodeRef = React.createRef();
        this.confirmationDialog = React.createRef();
        this.state = {  
            student: this.props.data.student, 
            startdate:this.props.data.startdate,
            enddate:this.props.data.enddate,            
            heightProportion: 1600,
            widthProportion: 500,
            listdiv:true,
            reportdiv:false,
            frmreport:this.props.data.frmreport,
            adddiv:false,
            editdiv:false,
            alllstdiv1:false,
        };

        this.onPrevSection = this.onPrevSection.bind(this); 
        this.onBacksection = this.onBacksection.bind(this); 
        this.onAddSession = this.onAddSession.bind(this);
        this.onListSession = this.onListSession.bind(this); 
        this.deleteForm = this.deleteForm.bind(this); 
    }

    editAssessment(assmval){
        var id=assmval.tsr_userID;
        var date=assmval.tsr_date;
        
        this.props.fetchCaptoReport(id, date).then((data) => {   
            var resdata=data.data;           

            this.setState({ 
                listdiv:false, 
                alllstdiv1:false,
                reportdiv:true,
            });

        });
    }

    onPrevSection(){
        var student=this.state.student;
        var stdate=this.state.startdate;
        var eddate=this.state.enddate;
        this.props.fetchPlayerCaptoLab(student, stdate, eddate);

        this.setState({
            reportdiv:false,
            alllstdiv1:false,
            adddiv:false,
            listdiv:true, 
        }); 
    }

    onAddSession(e, id) {
        e.preventDefault();
		this.setState({ 
         selfrom:id,
         listdiv:false,
         adddiv:true,
      });
    }
    
    onListSession(e, id) {
        e.preventDefault();
        if(id==1){
            var sellst='alllstdiv1';
        }

		this.setState({ 
         sellst:id,   
         [sellst]:true,   
         listdiv:false,
         adddiv:false,
      });
    }

    onBacksection(){
        var student=this.state.student;
        var stdate=this.state.startdate;
        var eddate=this.state.enddate;
        this.props.fetchPlayerCaptoLab(student, stdate, eddate);

        this.setState({ 
            alllstdiv1:false,  
            editdiv:false,
            adddiv:false,
            reportdiv:false,
            listdiv:true
        });
    }

    editAssessment2(assmval) {

        var id = assmval.tsr_userID;
        var date = assmval.tsr_date;
  
        this.props.fetchCaptoReport(id, date).then((data) => {
  
           this.setState({
                viewdiv: false,
                adddiv: false,
                alllstdiv1:false,      
                editdiv: true,
           });
  
        });
     }
  
  
     deleteForm(assmval) {
        this.id = assmval.tsr_userID;
        this.date = assmval.tsr_date;
        this.student=this.state.student;
        this.confirmationDialog.current.openDialog();
     }
  
     deleteDataPermanent(popupResponse) {
  
        if (popupResponse) {
           this.props.deleteCaptoReport(this.id, this.date);
           var student=this.student;
           this.props.fetchPlayerCaptoLab(student, '', '');
        }
     }



render() {
      
    const { playertechcapto, particularcaptoreport, loading} = this.props; 
    const stdrole = localStorage.getItem('stdrole');
    const options = {
        filterType: 'dropdown',
        rowsPerPage: 50,
        rowsPerPageOptions: [50, 100, 150],
        selectableRowsHideCheckboxes: true,
    };

    const columns = [
        { name: "no", label: "NO" },
        { name: "name", label: "NAME" },
        { name: "cdate", label: "DATE" },
        { name: "action", label: "REPORT" },
      
    ];
    const tabledata=playertechcapto.map((assmntval,idx) => {     
          
           const editBtn = (
            <IconButton className="text-info" aria-label="edit" onClick={() => this.editAssessment2(assmntval)}><EditOutlinedIcon/></IconButton>
         );
           const deleteBtn = (
            <IconButton
               className="text-danger"
               aria-label="Remove"
               onClick={() => this.deleteForm(assmntval)}
            >
               <DeleteOutlineOutlinedIcon/>
            </IconButton>
         );
            return {
            no:idx+1,
            name: assmntval.student,
            cdate: assmntval.cdate,
            action: (
                <div>
                   {editBtn} {deleteBtn}
                </div>
             ),
            
            }
    }); 
     
    if(particularcaptoreport.length==0){
        var exfiles=[];
        var filecnt=0; 
    }else{
        const allfile=particularcaptoreport[0].tsr_filename; 
             
        if(allfile==''){
            var exfiles=[];
            var filecnt=0;
        }else{
            var exfiles=allfile.split(',');
            var filecnt=exfiles.length;
        }
    }

    const styles = {
        subheading: {
            fontWeight:"bold"
        }

    }  

      return(
            <div>
                <div className="col-md-12 col-lg-12 col-sm-12">
                    <h1 className="text-center" style={{padding:"20px"}}> CAPTO PUTTING EVALUATION</h1>
                </div>

                {this.state.listdiv && 
                    <>
                    <div className="col-md-12 col-lg-12 col-sm-12" style={{marginBottom:"10px"}}>
                        <div className="ddd">
                            <div className="float-right"><Button onClick={this.props.onClick} className="btn btn-outline-warning"><KeyboardDoubleArrowLeftIcon aria-hidden="true" />  Back To Technology</Button></div>
                            
                        </div>
                    </div>
                    <div className="col-sm-12 col-lg-10" style={{margin:"0 auto"}}>                            
                            <RctCollapsibleCard heading="Report" chkbtn={stdrole==1? 0 :1 } addbtn onClickAdd={e => this.onAddSession(e, 1)} listbtn onClickList={e => this.onListSession(e, 1)}  fullBlock>
                            <div className="table-responsive reporttable">
                                <Table hover bordered striped>
                                    <thead>
                                        <tr className="bg-info text-white">
                                            <th>NO</th>
                                            <th>NAME</th>
                                            <th>DATE</th>
                                            <th>REPORT</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {playertechcapto.map((assmntval,idx) => {
                                            return (
                                                <tr>
                                                    <td>{idx+1}</td>
                                                    <td>{assmntval.student}</td>
                                                    <td>{assmntval.cdate}</td>
                                                    <td><a onClick={ ()=>this.editAssessment(assmntval)}><span className="badge badge-info" >View</span></a></td>                                                    
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table> 
                            </div>    
                        </RctCollapsibleCard>
                    </div>
                    </>
                }
                {this.state.reportdiv && 
                    <div className="col-md-12">
                        <div className="row">
                                <div className="col-sm-12 col-md-6">
                                    <RctCollapsibleCard heading="PUTTING EVALUATION DETAILS">
                                        <div className="float-right">
                                            <button type="button" className="mr-10 mb-10 btn btn-outline-warning " onClick={this.onPrevSection}>Back</button> 
                                        </div> 
                                        <div className="table-responsive">
                                            <Table hover bordered striped>
                                                
                                                <tbody>                              
                                                
                                                    <tr>
                                                        <td style={{width:"40%"}}>STUDENT</td>
                                                        <td style={styles.subheading}> {particularcaptoreport[0].student} </td>
                                                    </tr>
                                                    <tr>
                                                        <td>DATE</td>
                                                        <td style={styles.subheading}> {particularcaptoreport[0].cdate} </td>
                                                    </tr>
                                                    {particularcaptoreport.map((lumbval, idx) => (                                                   
                                                        <tr>
                                                            <td>{lumbval.gte_name}</td>
                                                            <td style={styles.subheading}> {lumbval.tsr_observation} </td>
                                                        </tr>                                                
                                                    ))}
                                                    <tr>
                                                        <td>Report Name</td>
                                                        <td style={styles.subheading}> {particularcaptoreport[0].tsr_reportname} </td>
                                                    </tr>

                                                                        
                                                </tbody>
                                            </Table>
                                        </div>   
                                    </RctCollapsibleCard>
                                </div> 
                                <div className="col-sm-12 col-md-6" ref={this.nodeRef}>
                                    <CarouselProvider                            
                                        naturalSlideWidth={this.state.widthProportion}
                                        naturalSlideHeight={this.state.heightProportion}
                                        totalSlides={filecnt}
                                    >
                                    <div className="sdfsdf">
                                        <div className="text-center" style={{marginTop:"-30px"}}>
                                            {exfiles.map((uptval,idx) => ( 
                                                <Dot className="text-center" slide={idx} >{idx+1}</Dot>
                                            ))}
                                        </div>                        
                                    </div>
                                    <Slider>
                                    {exfiles.map((uptval,idx) => (                                  
                                            <Slide index={idx}> 
                                            <RctCollapsibleCard>
                                                <iframe src={AppConfig.apiurl+'/theme/img/capto/'+uptval} width="100%" height={600} ></iframe>
                                            </RctCollapsibleCard>
                                            </Slide>
                                    ))}        
                                    </Slider>
                                    </CarouselProvider>    
                                </div>


                        </div>
                    </div>
                }

                {this.state.alllstdiv1 &&
                    <div className="col-sm-12 col-lg-10" style={{margin:"0 auto"}}>
                        <RctCollapsibleCard heading="List" backtoadd onClick={this.onPrevSection} fullBlock>
                            <MUIDataTable
                                data={tabledata}
                                columns={columns}
                                options={options}
                            />
                        </RctCollapsibleCard>
                    </div>
                }

                {this.state.adddiv &&
                   <AddItem onClick={this.onPrevSection} data={this.state}/> 
                }

                {this.state.editdiv &&
                    <EditForm onClick={this.onBacksection} data={this.state}/>
                }

                <ConfirmationDialog
                ref={this.confirmationDialog}
                onConfirm={(res) => this.deleteDataPermanent(res)}
                data={'capto putting report'}
                />

            </div>

              
    )
   
}
 
}

const mapStateToProps = ({ playerintervention, captoreport}) => {
   
    const { playertechcapto, loading } = playerintervention;
    const { particularcaptoreport } = captoreport;
    return { playertechcapto, particularcaptoreport, loading };   
}


export default connect(mapStateToProps, {
    fetchCaptoReport,
    fetchPlayerCaptoLab,
    deleteCaptoReport,
})(CaptoItems);
